import SourceSelection, {
  SourceSelectionTop,
} from '@chegg-wt/core/components/Layouts/SourceSelection'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import SEODeIndex from '@chegg-wt/core/components/Head/DeIndex'
import { AppState } from '@chegg-wt/core/state'
import { useRouter } from 'next/router'
import React from 'react'
import { connect } from 'react-redux'
import { EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import useUserRole from '@chegg-wt/core/hooks/useUserRole'
import useRedirect from '@chegg-wt/core/hooks/useRedirect'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { createCitationQuerySelector } from '@chegg-wt/core/state/createCitation/selectors'
import {
  getCapitalizedSEONameOfStyle,
  isStyleIdInValid,
} from '@chegg-wt/core/utils/styles'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { NextPageContext } from 'next'
import { matchSourceSegment } from '../../../utils/routes'
import { extendedConsiderCredibility } from '../../../copy/credibility'

interface SearchResultsPageProps {
  sourceSearchQuery: string
}

const SearchResultsPage: NextPageWithLayout<SearchResultsPageProps> = ({
  sourceSearchQuery,
}) => {
  const userRole = useUserRole()
  const { toDashboard } = useRoutesContext()
  useRedirect({
    shouldRedirect: userRole === UserRoles.PRO_USER,
    redirectRoute: toDashboard(),
  })

  const router = useRouter()
  const { style, source: sourceCitation, q: searchText } = router.query as {
    style: string
    source: string
    q: string
  }

  const {
    params: { source },
  } = matchSourceSegment(sourceCitation)

  const query = { searchText, style, source }
  const formattedStyle = getCapitalizedSEONameOfStyle(style)
  useOnUnloadTimeOnPage()

  return (
    <>
      <SEOTitle
        title={`${
          searchText || sourceSearchQuery
        } | ${formattedStyle} | ${EB_PRODUCT_NAME}`}
      />
      <SEODeIndex />
      <SourceSelection copy={extendedConsiderCredibility} query={query} />
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  sourceSearchQuery: createCitationQuerySelector(state),
})

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style } = query as { style: string }

  return {
    props: {},
    notFound: isStyleIdInValid(style),
  }
}

SearchResultsPage.getPageLayout = (page) =>
  getLvpLayout(page, () => <SourceSelectionTop />)

export default connect(mapStateToProps)(SearchResultsPage)
